import { TimerOptions } from 'types';
import { getDefaultTimer, timerStringToViewport } from 'utils/embed/timer';
import { updateState } from '../../shared/mutations';
import { TimerState, VideoTemplateStateContent } from '../../types';

export function setTimerOptions(
  state: VideoTemplateStateContent,
  timer: TimerOptions<string>,
) {
  if (!timer) return state;

  return updateState(state, {
    timer: timerStringToViewport(timer),
  });
}

export function setTimer(
  state: VideoTemplateStateContent,
  opts: Partial<TimerState>,
): VideoTemplateStateContent {
  if (!opts) return state;

  const { aspectRatio, timer: currentTimer } = state;

  return updateState(state, {
    timer: {
      ...(!currentTimer ? getDefaultTimer(aspectRatio) : undefined),
      ...opts,
    },
  });
}
